<template>
  <section class="ProductGallery" :class="{'zeborne': isZeborne}" v-if="productGallery && productGallery.images.length > 1">
    <div class="ProductGallery-gallery">
      <!-- Slider For -->
      <VueSlickCarousel ref="SliderFor" class="ProductGallery-sliderFor" v-bind="settings">
        <img class="ProductGallery-image lazyload" :data-src="productGallery.images[0]" />
        <iframe
          width="560"
          height="315"
          v-for="(imageVideo, index) in productVideos"
          :key="'video' + index"
          :src="imageVideo | formatVideoUrl"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
        <img
          v-for="(image, index) in productGallery.images.filter((image, key) => key > 0)"
          class="ProductGallery-image lazyload"
          :data-src="image"
          :key="'image' + index"
        />
      </VueSlickCarousel>
      <!-- Slider Nav -->
      <VueSlickCarousel
        v-if="productGallery.images.length > 1 || productVideos.length > 0"
        class="ProductGallery-sliderNav"
        v-bind="[isZeborne ? settingsForZeborne : settingsFor]"
      >
        <template #prevArrow="arrowOption">
          <div class="ProductGallery-arrow-up"></div>
        </template>
        <template #nextArrow="arrowOption">
          <div class="ProductGallery-arrow-down"></div>
        </template>
        <img
          class="ProductGallery-itemNav lazyload"
          @click="slideNav"
          :data-src="productGallery.images[0]"
        />
        <div
          class="ProductGallery-itemContainer"
          v-for="(imageVideo, index) in productVideos"
          :key="'video' + index"
          @click="slideNav"
        >
          <img
            :data-src="imageVideo | formatVideoThumbnail"
            class="ProductGallery-itemNav Video lazyload"
          />
          <svg v-svg symbol="Play" size="0 0 30 30" role="presentation" class="icon--inline"></svg>
        </div>
        <img
          v-for="(image, index) in productGallery.images.filter((image, key) => key > 0)"
          class="ProductGallery-itemNav lazyload"
          @click="slideNav"
          :data-src="image"
          :key="'image' + index"
        />
      </VueSlickCarousel>
    </div>

    <!-- Mask -->
    <div class="ProductGallery-mask">
      <div class="ProductGallery-masksIcons">
        <ul>
          <li v-for="(pictos, index) in productGallery.pictos" :key="pictos.label">
            <img :data-src="pictos" :alt="'product-picto-' + index" class="lazyload" />
          </li>
          <li
            v-for="(energyLabel, indexEnergy) in productGallery.energyLabel"
            :key="indexEnergy"
            :style="{ 'background-color': energyLabel.color }"
            class="ProductGallery-masksEnergy"
          >
            <p
              :class="{ hasColor: energyLabel.color !== '' }"
              :style="{ 'background-color': energyLabel.color }"
            >
              <span class="ProductGallery-masksEnergyValue">
                {{ getEnergyValueAndPlus(energyLabel.value).letter }}
                <span
                  class="ProductGallery-masksEnergyValuePlus"
                  v-if="getEnergyValueAndPlus(energyLabel.value).plus"
                >
                  {{ getEnergyValueAndPlus(energyLabel.value).plus }}
                </span>
              </span>
              {{ energyLabel.label }}
              <span class="before" :style="{ 'background-color': energyLabel.color }"></span>
              <span class="after" :style="{ 'background-color': energyLabel.color }"></span>
            </p>
          </li>
        </ul>

        <img :data-src="productGallery.brandImage" alt="brand-logo" class="lazyload" />
      </div>
      <div class="ProductGallery-masksCompare desktopOnly">
        <ProductCompare v-bind:product-id="productGallery.productId"></ProductCompare>
      </div>
      <div class="ProductGallery-masksZoom desktopOnly" @click="openModal">
        <svg
          v-svg
          symbol="FullScreen"
          size="0 0 16 16"
          role="presentation"
          class="icon--inline"
        ></svg>
      </div>
    </div>
    <div class="ProductGallery-modal" v-if="showModal" :class="{ display: showModal }">
      <div class="ProductGallery-modalInner"></div>
    </div>
    <transition name="slide-fade">
      <ModalZoom
        :showModal="showModal"
        v-if="showModal"
        :imageSrc="currentSlideSrc"
        :gallery="productGallery.images"
        @Modal::close="closeModal"
      ></ModalZoom>
    </transition>
  </section>

  <section class="ProductImage uniqueImage" v-else>
    <div class="ProductImage-container">
      <img class="ProductGallery-image lazyload" :data-src="productGallery.images[0]" />

      <!-- Mask -->
      <div class="ProductGallery-mask">
        <div class="ProductGallery-masksIcons">
          <ul>
            <li v-for="(pictos, index) in productGallery.pictos" :key="pictos.label">
              <img :data-src="pictos" :alt="'product-picto-' + index" class="lazyload" />
            </li>
            <li
              v-for="(energyLabel, indexEnergy) in productGallery.energyLabel"
              :key="indexEnergy"
              :style="{ 'background-color': energyLabel.color }"
              class="ProductGallery-masksEnergy"
            >
              <p
                :class="{ hasColor: energyLabel.color !== '' }"
                :style="{ 'background-color': energyLabel.color }"
              >
                <span>{{ energyLabel.value }}</span>
                {{ energyLabel.label }}
                <span class="before" :style="{ 'background-color': energyLabel.color }"></span>
                <span class="after" :style="{ 'background-color': energyLabel.color }"></span>
              </p>
            </li>
          </ul>

          <img :data-src="productGallery.brandImage" alt="brand-logo" class="lazyload" />
        </div>
        <div class="ProductGallery-masksCompare desktopOnly">
          <ProductCompare v-bind:product-id="productGallery.productId"></ProductCompare>
        </div>
        <div class="ProductGallery-masksZoom desktopOnly" @click="openModal">
          <svg
            v-svg
            symbol="FullScreen"
            size="0 0 16 16"
            role="presentation"
            class="icon--inline"
          ></svg>
        </div>
      </div>
    </div>
    <div class="ProductGallery-modal" v-if="showModal" :class="{ display: showModal }">
      <div class="ProductGallery-modalInner"></div>
    </div>
    <transition name="slide-fade">
      <ModalZoom
        :showModal="showModal"
        v-if="showModal"
        :imageSrc="currentSlideSrc"
        :gallery="productGallery.images"
        @Modal::close="closeModal"
      ></ModalZoom>
    </transition>
  </section>
</template>

<script>
import "@/components/Product/ProductGallery/ProductGallery.scss";
import VueSlickCarousel from "vue-slick-carousel";
import ProductCompare from "@/includes/Product/ProductCompare/ProductCompare.vue";
import { mapGetters } from "vuex";
import galleryMixin from "@/mixins/galleryMixin";
import ModalZoom from "@/components/Modal/ModalZoom.vue";

export default {
  name: "ProductGallery",
  mixins: [galleryMixin],
  components: {
    VueSlickCarousel,
    ProductCompare,
    ModalZoom,
  },

  computed: {
    ...mapGetters({ productGallery: "getProductGallery" }),
    ...mapGetters({ productVideos: "getProductVideos" }),
    ...mapGetters({ isZeborne: "isZeborne" }),
  },

  data() {
    return {
      showModal: false,
      slidesToShowNav: 0,
      modalIsZoom: true,
      currentSlideSrc: "",
    };
  },
  methods: {
    openModal() {
      this.showModal = true;
      if (this.productGallery.images.length === 1) {
        this.currentSlideSrc = this.productGallery.images[0];
      } else {
        this.currentSlideSrc = this.productGallery.images[
          this.$refs.SliderFor.$refs.innerSlider.currentSlide
        ];
      }
    },
    closeModal() {
      this.showModal = false;
    },

    getEnergyValueAndPlus(value) {
      const index = value.indexOf("+");

      return {
        letter: index !== -1 ? value.slice(0, index) : value,
        plus: index !== -1 ? value.slice(index, value.length) : "",
      };
    },
  },
};
</script>
